var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.collapse)?_c('div',{class:_vm.collapse ? 'menu-bar-collapse-width' : 'menu-bar-container'},_vm._l((_vm.navTreeChild),function(item){return _c('menu-tree',{key:item.id,attrs:{"menu":item}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }